exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.quill-editor.is-invalid {\n  border-color: #f35a3d;\n}\n", ""]);
